import { ca } from "zod/v4/locales";




const initOnlineUsers = localStorage.getItem('onlineUsers');


const initState = {
  onlineUsers: initOnlineUsers ? JSON.parse(initOnlineUsers) : [],
};

export const onlineUsersReducer = (state = initState, action) => {
  switch (action.type) {
    case 'onlineUsers/SET_ONLINE_USERS':
      return { ...state, onlineUsers: action.payload };
    case 'onlineUsers/CLEAR_ONLINE_USERS':
      return { ...state, onlineUsers: [] };
    case 'onlineUsers/ADD_ONLINE_USER':
      return { ...state, onlineUsers: [...state.onlineUsers, action.payload] };
    case 'onlineUsers/UPDATE_ONLINE_USER':
      return {
        ...state,
        onlineUsers: state.onlineUsers.map(user =>
          user.id === action.payload.id ? action.payload : user
        ),
      };
    case 'onlineUsers/REMOVE_ONLINE_USER':
      return {
        ...state,
        onlineUsers: state.onlineUsers.filter(user => user.id !== action.payload),
      };
    default:
      return state;
    }
  }